import { v4 as uuidv4 } from "uuid";
import rawcotton from "../../assets/img/project/rawcotton.jpg";
import OilMeals from "../../assets/img/project/OilMeals.jpg";
import CommercialOils from "../../assets/img/project/CommercialOils.jpg";
import ConsumerEdibleOils from "../../assets/img/project/ConsumerEdibleOils.jpg";
import CottonYarns from "../../assets/img/project/CottonYarns.jpg";
import DeOiled from "../../assets/img/project/De-OiledCakes.jpg";
import OilCakesCattleFeeds from "../../assets/img/project/OilCakesCattleFeeds.jpg";

const portfolioTwoData = [
  {
    id: uuidv4(),
    img: OilMeals,

    location: "Oil seeds / Grains / Pulses",

    index: "01",
    link: "/Seeds",
  },
  {
    id: uuidv4(),
    img: rawcotton,

    location: "Raw Cotton ",

    index: "02",
    link: "/raw_cotton",
  },

  {
    id: uuidv4(),
    img: ConsumerEdibleOils,

    location: "Consumer Edible Oils",

    index: "03",
    link: "/ConsumerEdibleOils",
  },

  {
    id: uuidv4(),
    img: CommercialOils,

    location: "Commercial Oils ",

    index: "04",
    link: "/CommercialOils",
  },

  {
    id: uuidv4(),
    img: OilCakesCattleFeeds,

    location: "Oil Cakes (Cattle Feeds)",

    index: "05",
    link: "/OilCakes",
  },
  {
    id: uuidv4(),
    img: DeOiled,

    location: "Oil Meals (Solvent Extracted De-Oiled Cakes)",

    index: "06",
    link: "/OilMeals",
  },
 
  {
    id: uuidv4(),
    img: CottonYarns,

    location: "Cotton Yarns",

    index: "07",
    link: "/CottonYarns",
  },
];

export default portfolioTwoData;
